// @ts-check
import React, { Component, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import MdcAppLoader from './MdcAppLoader'

const PlaylistsEmbedStandAlone = React.lazy(
  () => import('./PlaylistsEmbedStandAlone' /* webpackChunkName: "PlaylistsEmbedStandAlone" */)
)

/**
 * @extends {React.Component}
 */
class PlaylistsEmbedStandAloneLoader extends Component {
  componentDidMount() {
    const container = document.getElementById('mdcListsEmbed')
    if (container) {
      const root = createRoot(container)
      const listID = container.getAttribute('data-listid')
      if (listID) {
        root.render(
          <Suspense fallback={<MdcAppLoader />}>
            <PlaylistsEmbedStandAlone listID={listID} />
          </Suspense>
        )
      }
    }
  }

  render() {
    // do not render anything, rely on ComponentDidMount for render
    return <></>
  }
}

export default PlaylistsEmbedStandAloneLoader
